import { PAGES_ACTIONS } from './pages.types';
export const setPagesAction = (payload) => ({
    type: PAGES_ACTIONS.SET_PAGES,
    payload
});
export const setPageAction = (payload) => ({
    type: PAGES_ACTIONS.SET_PAGE,
    payload
});
export const addPageAction = (payload) => ({
    type: PAGES_ACTIONS.ADD_PAGE,
    payload
});
export const updatePageAction = (payload) => ({
    type: PAGES_ACTIONS.UPDATE_PAGE,
    payload
});
export const removePageAction = (payload) => ({
    type: PAGES_ACTIONS.REMOVE_PAGE,
    payload
});
export const setPagesStatusAction = (payload) => ({
    type: PAGES_ACTIONS.SET_STATUS,
    payload
});
export const setPageCurrentStatusAction = (payload) => ({
    type: PAGES_ACTIONS.SET_CURRENT_STATUS,
    payload
});
export const setPagesErrorsAction = (payload) => ({
    type: PAGES_ACTIONS.SET_ERRORS,
    payload
});
export const clearPagesErrorsAction = () => ({
    type: PAGES_ACTIONS.CLEAR_ERRORS
});
export const clearPagesAction = () => ({
    type: PAGES_ACTIONS.CLEAR_PAGES
});
export const clearPageCurrentAction = () => ({
    type: PAGES_ACTIONS.CLEAR_CURRENT
});
